module.exports = __webpack_public_path__ + "img/Imaginative Mind.7a268ba9.svg";